import { createContext, PropsWithChildren } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { FormProvider } from '../forms/FormProvider';
import { ModelContext } from './ModelProvider';
import { useRhinoDevtoolsEmit } from '../../hooks/dev';
import { RhinoResource } from '../../index';

// Dynamic controller-state bag; consumers read many runtime fields.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ModelEditContextValue = Record<string, any>;

export const ModelEditContext = createContext<
  ModelEditContextValue | undefined
>(undefined);

interface ModelEditProviderProps {
  methods: UseFormReturn;
  model?: RhinoResource;
  [key: string]: unknown;
}

export const ModelEditProvider = ({
  children,
  ...props
}: PropsWithChildren<ModelEditProviderProps>) => {
  const { methods, ...context } = props;
  const { model } = context;

  useRhinoDevtoolsEmit({ type: 'ModelEditContext', context });

  return (
    <ModelContext value={{ model }}>
      <ModelEditContext value={{ ...props }}>
        <FormProvider {...methods}>{children}</FormProvider>
      </ModelEditContext>
    </ModelContext>
  );
};
